import taskManagementActionsHandlers from "@actions/taskManagement/taskManagementActionsHandlers";
import inventoryActionsHandlers from "./inventory/inventoryActionsHandlers";
import procurementsActionsHandlers from "./procurements/procurementsActionsHandlers";

const allActionsHandlers = {
  ...taskManagementActionsHandlers,
  ...inventoryActionsHandlers,
  ...procurementsActionsHandlers,
};

export default allActionsHandlers;
